<template>
    <div>
      <ViewTemplate :table-props="mappingColumns" :project-param-id="projectParamId" :mapper-param-id="mapperParamId"/>
    </div>
</template>

<script>

import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import TabContentView from "./TabContentView.vue";
import ViewTemplate from "@/components/ViewTemplate.vue";
export default {
    name: pageViews.ACTIVITIES_VIEW,
    methods: {
        setValuesToStore(type) {
            Store.commit("setType", type);
        }
    },
    mounted() {
        this.setValuesToStore(type.MAPPER_ACTIVITY);
        console.log("Type passed to ViewTemplate:", type.MAPPER_ACTIVITY); // Debugging log
        console.log("Mapping Columns:", this.mappingColumns); // Debugging log
    },
    components: {
      TabContentView,
      ViewTemplate
    },
    data() {
      return {
        uploadConfigs: {
          action: "generator",
          actionLabel: "Generator",
          title: "Mapper Config Generator",
          type: type.MAPPER_ACTIVITY,
          accept: ".zip",
        },
        mappingColumns: {
          type: type.MAPPER_ACTIVITY, // Ensure this matches the backend expectation
          isMultiSelectionAllowed: true,
          defaultSortOrder: { name: "asc", label: "Ascending" },
          defaultSortColumn: { name: "Process", label: "Process" },
          configs: [
            { name: "usecaseLocation", label: "Use Case Location", order: 0, isSortable: true, defaultSelected: false, textAlign: "left" },
            { name: "usecase", label: "Use Case", order: 1, isSortable: true, defaultSelected: true, textAlign: "left" },
            { name: "processLocation", label: "Process Location", order: 2, isSortable: true, defaultSelected: false, textAlign: "left" },
            { name: "process", label: "Process", order: 3, isSortable: true, defaultSelected: true, textAlign: "left" },
            { name: "activity", label: "Activity", order: 4, isSortable: true, type: "int",defaultSelected: true,textAlign: "left" },
            { name: "activityType", label: "Activity Type", order: 5, isSortable: true, defaultSelected: true , textAlign: "left"},
            { name: "isUsageActivitiesStarter", label: "Is Starter", order: 6, isSortable: true, defaultSelected: true , textAlign: "left"},
            { name: "input", label: "Input", order: 8, isSortable: true, defaultSelected: true , textAlign: "left"},
            { name: "output", label: "Output", order: 9, isSortable: true, defaultSelected: true , textAlign: "left"},
            { name: "subProcessLocation", label: "Supporting Process Location", order: 10, isSortable: true, defaultSelected:true , textAlign:"left"},
            { name:"subProcess",label:"Supporting Process",order :11,isSortable:true,defaultSelected:true,textAlign:"left"}, 
        ],
        actions: {
          viewPopup: { label: 'View Output' },
          download: { label: 'Request Download' },
          calculate: { label: 'Calculate Complexity' },
        },
      },
     };
  },
  props: ["projectParamId", "mapperParamId"],
}

</script>
